import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function SeoContent() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-16">
          <div className="w-full lg:w-[55%]">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
              {t('seo.title')}
            </h2>
            <div className="mt-6 space-y-4">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                {t('seo.paragraph1')}
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                {t('seo.paragraph2')}
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                {t('seo.paragraph3')}
              </p>
            </div>

            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/article/chto-takoe-yoybuy-spreadsheet"
                className="inline-flex items-center gap-2 px-5 py-3 bg-accent-500 text-background-50 text-sm font-medium rounded-full hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                {t('seo.read_guide')}
              </Link>
              <Link
                to="/article/gid-po-pokupkam"
                className="inline-flex items-center gap-2 px-5 py-3 border-2 border-accent-500 text-accent-600 text-sm font-medium rounded-full hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                Гид по покупкам →
              </Link>
            </div>

            <div className="mt-12 flex flex-wrap gap-10 md:gap-16">
              <div>
                <p className="text-3xl md:text-4xl font-extrabold text-foreground-950">
                  {t('seo.stat1_value')}
                </p>
                <p className="mt-1 text-xs text-foreground-500 font-light">
                  {t('seo.stat1_label')}
                </p>
              </div>
              <div>
                <p className="text-3xl md:text-4xl font-extrabold text-foreground-950">
                  {t('seo.stat2_value')}
                </p>
                <p className="mt-1 text-xs text-foreground-500 font-light">
                  {t('seo.stat2_label')}
                </p>
              </div>
              <div>
                <p className="text-3xl md:text-4xl font-extrabold text-foreground-950">
                  {t('seo.stat3_value')}
                </p>
                <p className="mt-1 text-xs text-foreground-500 font-light">
                  {t('seo.stat3_label')}
                </p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[45%]">
            <div className="rounded-2xl overflow-hidden bg-background-100 aspect-[4/5] relative">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20cozy%20workspace%20scene%20with%20laptop%20open%20showing%20spreadsheet%20next%20to%20fashion%20sneakers%20and%20coffee%20on%20warm%20wooden%20desk%2C%20soft%20golden%20morning%20light%20through%20large%20window%20with%20plants%2C%20relaxed%20productive%20atmosphere%2C%20editorial%20lifestyle%20photography%2C%20warm%20inviting%20natural%20tones%20with%20gentle%20depth%20of%20field&width=600&height=750&seq=seo-content-v2-01&orientation=portrait"
                alt={t('seo.image_label')}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute top-4 left-4">
                <span className="inline-block px-3 py-1.5 bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-800 rounded-full">
                  {t('seo.image_label')}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}